export default "__VITE_ASSET__COhtjTj8__"